import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { Credential, LoginResponse, TokenData } from '../models/User';
import { environment } from '../../environments/environment';
import { SseClientService } from '../helpers/sse-client.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private LOGGIN_URL = environment.apiUrl + "portal/login"
  private authToken = "authToken"
  private tokenData = "tokenData"

  //sseClientServ: SseClientService = inject(SseClientService);

  constructor(private httpClient: HttpClient, private router: Router) { }

  login(username: string, password: string): Observable<LoginResponse> {
    const credential: Credential = {
      username: username,
      password: password
    }
    return this.httpClient.post<LoginResponse>(this.LOGGIN_URL, credential).pipe(
      tap(response => {
        if (response) {
          this.setToken(response.token)
          this.setTokenData(response.token)
          this.getTokenData();
          
        }
      })
    )
  }

  private setToken(token: string): void {
    localStorage.setItem(this.authToken, token)
  }

  private getToken(): string | null {
    return localStorage.getItem(this.authToken)
  }

  private setTokenData(token: string): void {
    const payload = JSON.parse(atob(token.split('.')[1])) as TokenData;
    const base64Decode = (base64EncodedString: any) =>
      new TextDecoder().decode(Uint8Array.from(atob(base64EncodedString), m => m.charCodeAt(0)));
    payload.name = base64Decode(payload.name);

    localStorage.setItem(this.tokenData, JSON.stringify(payload));
  }

  getTokenData(): TokenData | null {
    const data = localStorage.getItem(this.tokenData);    
    return data ? JSON.parse(data) as TokenData : null;    
  }
/*
  initEventNotification(){
    const data = localStorage.getItem(this.tokenData);    
    const userId = JSON.parse(data||'').id;
    if (!userId){
      console.warn("No se encontró userId en el token. No se iniciará la conexión SSE.");
    }
    this.sseClientServ.setUserId(userId||""); // Asignar el userId al servicio SSE
    
    console.log('Ingreso');
      // Conectar cuando la página cargue
      document.addEventListener('DOMContentLoaded', () => {
          this.sseClientServ.connect();
          console.log('conectado SSE');
      });

      // Desconectar cuando se cierre la página
      window.addEventListener('beforeunload', () => {
          this.sseClientServ.disconnect();
          console.log('Desconectando SSE');
      });

  }
*/
  resetPassword(usuario: string, correo: string  ):Observable<String>{
    return this.httpClient.post(environment.apiUrl+"u/rc",{usuario: usuario, correo:correo},{
      responseType: 'text',
    })
  }

  isAuthenticated(): boolean {
    const token = this.getToken()
    if (!token) {
      //this.sseClientServ.disconnect();
      return false
    }
    const payload = JSON.parse(atob(token.split('.')[1]))
    const exp = payload.exp * 1000
    return Date.now() < exp
  }

  logout(): void {    
    localStorage.removeItem(this.authToken)
    localStorage.removeItem(this.tokenData)
    //this.sseClientServ.disconnect();
    this.router.navigate(["/login"])
  }
  
}
